import React from 'react';

import GrafanaIcon from '../../images/icons/grafana.svg';

export const GrafanaLogo = () => {
  return <img height="18" src={GrafanaIcon} alt="Grafana logo" />;
};
